import { render } from "./Pixabay.vue?vue&type=template&id=c52d597a&scoped=true&ts=true"
import script from "./Pixabay.vue?vue&type=script&lang=ts"
export * from "./Pixabay.vue?vue&type=script&lang=ts"

import "./Pixabay.vue?vue&type=style&index=0&id=c52d597a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c52d597a"]])

export default __exports__